export const initialState = {
  searchText: '',
  isFuzzySearch: false,
  isInitialized: false,
};

export default initialState;
